import { createTheme as createMuiTheme, ThemeOptions, Theme } from '@mui/material'

export const createTheme = (options?: ThemeOptions): Theme => {
    const customOptions: ThemeOptions = {
        components: {
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true,
                },
                styleOverrides: {
                    root: {
                        fontFamily: 'Open Sans',
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontFamily: 'Open Sans',
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        '&.Mui-disabled': {
                            backgroundColor: '#F3F7F9',
                            color: '#ACC0CA',
                            cursor: 'no-drop',
                        }
                    },
                    notchedOutline: {
                        '&.error fieldset': {
                            borderColor: 'red',
                        },
                    }
                }
            },
            MuiSelect: {
                styleOverrides: {
                    select: {
                        color: '#5B6971',
                        backgroundColor: '#F3F7F9',
                        borderColor: '#87969C',

                        '&.mui-select-error': {
                            borderColor: 'red',
                        },

                        '&.Mui-disabled': {
                            backgroundColor: '#F3F7F9',
                            color: '#ACC0CA',
                            cursor: 'no-drop',
                        }
                    }
                }
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        backgroundColor: '#F3F7F9',

                        '&.Mui-disabled': {
                            backgroundColor: '#F3F7F9',
                            color: '#ACC0CA',
                            cursor: 'no-drop',
                        }
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        '&.Mui-disabled': {
                            backgroundColor: '#F3F7F9',
                            color: '#ACC0CA',
                            cursor: 'no-drop',
                        }
                    }
                }
            }
        }
    }

    const theme = createMuiTheme(customOptions, options)

    return theme
}

export { ThemeProvider } from '@mui/material'